import makeService from './api';

export default makeService('products');
